module.exports = __webpack_public_path__ + "assets/img/image02.077559f9.png";